/* eslint-disable max-len */
import React from 'react';
function Succession() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6923 11.5888C14.1067 11.5888 16.0623 9.66704 16.0623 7.29439C16.0623 4.92174 14.1067 3 11.6923 3C9.27785 3 7.32227 4.92174 7.32227 7.29439C7.32227 9.66704 9.27785 11.5888 11.6923 11.5888ZM10.5712 15.6626C5.80929 15.6626 4.57666 18.4527 4.85691 20.1H6.76167V22H2.95215V19.6242C2.95215 13.2268 10.556 13.451 10.556 13.451L10.5712 15.6626ZM8.66678 18.2V22H11.5239V18.2H8.66678ZM13.4285 22L13.4285 13.45H16.2856V22H13.4285ZM18.1907 9.65V22H21.0479V9.65H18.1907Z" })));
}
export default Succession;
